import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApprovedDetailsService {

  constructor(public http: HttpClient) { }

  public getApprovedDetails(applicationId):Observable<any>{
    return this.http.get(environment.BASE_URL_DAS+'das/getApprovedDetails/'+applicationId);
  }

  public getApprovedDetailsForDas(applicationId):Observable<any>{
    return this.http.get(environment.BASE_URL_PCD+'api/das/'+applicationId+'/approved-details');
  }

  /** PCD — approved letter PDF (raw bytes, same as public HEC verification screen). */
  public generateLetterByDasDegreeId(dasDegreeId: number | string, cnic: string): Observable<Blob> {
    const id = dasDegreeId != null && String(dasDegreeId).trim() !== '' ? String(dasDegreeId).trim() : '';
    const cnicPath = cnic != null && String(cnic).trim() !== '' && String(cnic) !== 'undefined'
      ? String(cnic).trim()
      : '';
    return this.http.get(
      environment.BASE_URL_PCD + 'api/das/generateLetter/' + encodeURIComponent(id) + '/' + encodeURIComponent(cnicPath),
      { responseType: 'blob' }
    );
  }
}
